import { SpintrTypes } from "src/typings";

export function selectAppEnabled(
    appState: Spintr.AppState,
    app: SpintrTypes.SpintrApp,
): boolean {
    return appState.app.items.some(
        (a) => a.enabled && a.id === app,
    );
}

